// extracted by mini-css-extract-plugin
module.exports = {"list":"item_list__DKcez","item":"item_item__BkU2P"};